let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iOdZN")).then(() => parcelRequire('bIsTX'));